import Api from "./api";

class ItemService {
    api = new Api();

    getItem(itemId) {
        return this.api.get('/catalog/item/get-item', {
            itemId: itemId
        });
    }
}

export default new ItemService();